import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { CommonMethods } from "@services/common.method";
import { NotificationsService } from "@shared/services/notification";
import { PaymentType } from "@fs/enums/common";
import { AuthService } from "@services/auth.service";
import { Constants } from '@constants';
import { AppConfig } from "@appconfig";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { PaymentModel } from "src/app/fs-lte/models/work-order-review/work-order-review.mode";
import { WorkOrderReviewService } from "@fs/services/work-order-review";
import { TabOpenService } from "@services/tab-open.service";
import { PermissionPipe } from "@shared/pipes/permission";
import { ActionName } from "@shared/enums/action-name";
import { SpinnerService } from '@shared/services/spinner.service';

@Component({
  selector: 'wo-add-payment',
  templateUrl: './wo-add-payment.component.html',
  styleUrls: ['./wo-add-payment.component.scss']
})
export class WoAddPaymentComponent implements OnInit {

  //#region Input/Output/ViewChild
  @Input() subStatus: string;
  @Input() paymentTypes: any;
  @Input() details: any;
  @Input() paymentDisabled: boolean = false;
  @Input() workTicketPayment: any;
  @Input() destroyTab: Boolean = false;
  @Input() tabCounter: number;
  @Input() minAmount: number;

  @Output() EvPaymentUpdated = new EventEmitter();
  //#endregion

  //#region Variable Declaration
  
  public qbVersion: string;
  public paymentConfirmBtnText: string = "Confirm & Pay";
  public invalidExpiry: boolean = false;
  public showPaymentOverlay: boolean;
  public confirmationBox: boolean
  public confirmMessage: string = "";
  public confirmActionCancelBtn: string = "";
  public confirmActionOkBtn: string = "";
  public isError: boolean = false;
  public paygatewayResponse: any = { Token: String, ValidationMessage: String };
  public paymentForm: FormGroup;

  public get paymentSelectorCash(): boolean {
    return this._paymentSelectorCash;
  }
  public set paymentSelectorCash(value) {
    this._paymentSelectorCash = value;
    this.showPaymentOverlay = value;
  }

  public get paymentSelectorCredit(): boolean {
    return this._paymentSelectorCredit;
  }
  public set paymentSelectorCredit(value) {
    this._paymentSelectorCredit = value;
    this.showPaymentOverlay = value;
  }

  public get paymentSelectorCheck(): boolean {
    return this._paymentSelectorCheck;
  }
  public set paymentSelectorCheck(value) {
    this._paymentSelectorCheck = value;
    this.showPaymentOverlay = value;
  }

  public get paymentSelectorOther(): boolean {
    return this._paymentSelectorOther;
  }
  public set paymentSelectorOther(value) {
    this._paymentSelectorOther = value;
    this.showPaymentOverlay = value;
  }

  public paymentURL: string;
  public creditCardForm: FormGroup;
  public isCreditPaymentAllowed: boolean = false;
  public hasWOReviewEditPermission: boolean = true;
  public isUnsavedTriggered: boolean = false;
  public monthsList = [
    { Name: "January", Value: "01" },
    { Name: "February", Value: "02" },
    { Name: "March", Value: "03" },
    { Name: "April", Value: "04" },
    { Name: "May", Value: "05" },
    { Name: "June", Value: "06" },
    { Name: "July", Value: "07" },
    { Name: "August", Value: "08" },
    { Name: "September", Value: "09" },
    { Name: "October", Value: "10" },
    { Name: "November", Value: "11" },
    { Name: "December", Value: "12" }
  ];
  public yearList: any = [];

  private paymentType: PaymentType = PaymentType.None;
  private _paymentSelectorCash;
  private _paymentSelectorCredit;
  private _paymentSelectorCheck;
  private _paymentSelectorOther;
  private modalCounter: number;

  
  //#endregion

  //#region Constructor
  constructor(
    private auth: AuthService,
    private toastr: NotificationsService,
    private appConfig: AppConfig,
    private frmbuilder: FormBuilder,
    private commonMethods: CommonMethods,
    private httpWOReviewService: WorkOrderReviewService,
    private permissionPipe: PermissionPipe, 
    private tabOpen: TabOpenService,
    private $viewContainerRef: ViewContainerRef,
    private spinnerServ: SpinnerService) {
    this.paymentURL = this.appConfig.getEndPoints().PaymentProcessorCardConnectEndPoint;
  }
  //#endregion

  //#region Lifecycle Events
  ngOnInit() {
    this.qbVersion = (this.auth.getCompanyQBType()).toLowerCase();
    this.modalCounter = this.commonMethods.generateDynamictabCounter();
    this.hasWOReviewEditPermission = this.permissionPipe.transform(ActionName.EditWorkOrderReview);
    this.isCreditPaymentAllowed = this.auth.getCreditPaymentAllowed();
    this.FillYearList();
  }

  //#endregion

  //#region Methods
  public OpenPaymentSelector(paymentType: PaymentType) {
    if (!this.paymentDisabled) {
      let warningMsg = "This payment will automatically post to QuickBooks";
      let btnOkText = "Ok";
      let btnCancelText = "Cancel";
      if (this.qbVersion != "none" && this.subStatus == Constants.WOStaticStatus().posted) {
        this.paymentConfirmBtnText = "Pay & Post";
      }
      switch (paymentType) {
        case PaymentType.CreditCard:
          {
            if (this.IsShowConfirmBox()) {
              this.confirmationBox = true;
              this.ShowPaymentConfirmBox(warningMsg, btnOkText, btnCancelText, PaymentType.CreditCard);
            }
            else
              this.OpenPaymentSelectorCreditModal();
          }
          break;
        case PaymentType.Cash:
          {
            if (this.IsShowConfirmBox()) {
              this.confirmationBox = true;
              this.ShowPaymentConfirmBox(warningMsg, btnOkText, btnCancelText, PaymentType.Cash);
            }
            else
              this.OpenPaymentSelectorCashModal();
          }
          break;
        case PaymentType.Cheque:
          {
            if (this.IsShowConfirmBox()) {
              this.confirmationBox = true;
              this.ShowPaymentConfirmBox(warningMsg, btnOkText, btnCancelText, PaymentType.Cheque);
            }
            else
              this.OpenPaymentSelectorCheckModal();
          }
          break;
        case PaymentType.Other:
          {
            if (this.IsShowConfirmBox()) {
              this.confirmationBox = true;
              this.ShowPaymentConfirmBox(warningMsg, btnOkText, btnCancelText, PaymentType.Other);
            }
            else
              this.OpenPaymentSelectorOtherModal();
          }
          break;
      }
    }
  }

  public OpenPaymentSelectorCheckModal() {
    if (this.paymentDisabled == false) {
      this.paymentSelectorCash = false;
      this.paymentSelectorCredit = false;
      this.paymentSelectorOther = false;
      this.paymentSelectorCheck = true;
      this.InitializePaymentForm(3);
    }
  }

  public ClosePaymentSelectorCheckModal() {
    if (this.paymentForm.dirty) {
      this.tabOpen.DestroyTab(this.tabCounter, "modal");
    } else {
      this.paymentSelectorCheck = false;
    }
  }

  public OpenPaymentSelectorCashModal() {
    if (this.paymentDisabled == false) {
      this.paymentSelectorCredit = false;
      this.paymentSelectorCheck = false;
      this.paymentSelectorOther = false;
      this.paymentSelectorCash = true;
      this.InitializePaymentForm(2);
    }
  }

  public OpenPaymentSelectorCreditModal() {
    if (this.paymentDisabled == false) {
      this.paymentSelectorCash = false;
      this.paymentSelectorCheck = false;
      this.paymentSelectorOther = false;
      this.paymentSelectorCredit = true;
      this.InitializeCreditCardForm();
    }
  }

  public OpenPaymentSelectorOtherModal() {
    if (this.paymentDisabled == false) {
      this.paymentSelectorCash = false;
      this.paymentSelectorCheck = false;
      this.paymentSelectorCredit = false;
      this.paymentSelectorOther = true;
      this.InitializePaymentForm(4);
    }
  }

  public ClosePaymentSelectorCashModal() {
    if (this.paymentForm.dirty) {
      this.tabOpen.DestroyTab(this.tabCounter, "modal");
    } else {
      this.paymentSelectorCash = false;
    }
  }

  public ClosePaymentSelectorCreditModal() {
    if (this.creditCardForm.dirty) {
      this.tabOpen.DestroyTab(this.tabCounter, "modal");
    } else {
      this.paymentSelectorCredit = false;
    }
  }

  public ClosePaymentSelectorOtherModal() {
    if (this.paymentForm.dirty) {
      this.tabOpen.DestroyTab(this.tabCounter, "modal");
    } else {
      this.paymentSelectorOther = false;
    }
  }

  public SaveCashPayment() {
    if (this.paymentForm.valid) {
      let payment: PaymentModel = new PaymentModel();
      payment.WorkOrder = Object.assign({}, { ID: this.details.ID });
      let paymentType = this.paymentTypes.find(
        x => x.Code.toLowerCase() == "cash"
      );
      payment.PaymentType = paymentType;
      payment.Amount = parseFloat(
        this.paymentForm.controls["Amount"].value.toFixed(2)
      );
      payment.Comment = this.paymentForm.controls["Comment"].value;
      this.spinnerServ.showloader(this.$viewContainerRef, this.modalCounter, 0);
      this.httpWOReviewService.SavePayment(payment).subscribe(
        response => {
          if (response != null) {
            this.details.WorkTicketPayment = response;
            this.EvPaymentUpdated.emit(response);
          }
          this.spinnerServ.hideLoader(this.$viewContainerRef, this.modalCounter);
          this.paymentSelectorCash = false;
          this.ShowPostToAccToast(response);
          this.toastr.success("Payment saved successfully", "Success!");
          this.paymentForm.markAsPristine();
          if (this.destroyTab) {
            setTimeout(() => {
              this.tabOpen.DestroyTab(this.tabCounter);
            }, 100);
          }
          else {
            this.tabOpen.unsavedChangedDetected({
              dirty: false,
              Index: this.tabCounter
            });
            this.isUnsavedTriggered = false;
          }
        },
        error => {
          this.spinnerServ.hideLoader(this.$viewContainerRef, this.modalCounter);
          if (!CommonMethods.CheckNullOrUndefined(error.error))
            this.toastr.showMultiLineError(error.error.Message, "Error");
        }
      );
    } else {
      this.commonMethods.markFormGroupTouched(this.paymentForm);
    }
  }

  public ConfirmAction(val) {
    if (val) {
      switch (this.paymentType) {
        case PaymentType.CreditCard:
          this.OpenPaymentSelectorCreditModal();
          break;
        case PaymentType.Cash:
          this.OpenPaymentSelectorCashModal();
          break;
        case PaymentType.Cheque:
          this.OpenPaymentSelectorCheckModal();
          break;
        case PaymentType.Other:
          this.OpenPaymentSelectorOtherModal();
          break;
      }

      this.paymentType = PaymentType.None;
      this.HideAndClearConfimBox();
    }
    else {
      this.paymentType = PaymentType.None;
      this.HideAndClearConfimBox();
      this.showPaymentOverlay = false;
    }

  }

  public ClosePaymentModal() {
    this.paymentSelectorCash = false;
    this.paymentSelectorCheck = false;
    this.paymentSelectorCredit = false;
    this.paymentSelectorOther = false;

    if (!CommonMethods.CheckNullOrUndefined(this.paymentForm))
      this.paymentForm.markAsPristine();
    if (!CommonMethods.CheckNullOrUndefined(this.creditCardForm))
    this.creditCardForm.markAsPristine();
    if (this.destroyTab) {
      setTimeout(() => {
        this.tabOpen.DestroyTab(this.tabCounter);
      }, 100);
    }
    else {
      this.tabOpen.unsavedChangedDetected({
        dirty: false,
        Index: this.tabCounter
      });
      this.isUnsavedTriggered = false;
    }
  }

  public SaveCommonPaymentDetail() {
    if (this.paymentSelectorCredit) {
      this.SaveCreditCardPayment();
    } else if (this.paymentSelectorCash) {
      this.SaveCashPayment();
    } else if (this.paymentSelectorCheck) {
      this.SaveChequPayment();
    } else if (this.paymentSelectorOther) {
      this.SaveOtherPayment();
    }
  }

  public SaveCreditCardPayment() {
    let accountNo = $("#token").val();
    if (accountNo == "" || accountNo == null || !this.creditCardForm.valid) {
      if (!this.creditCardForm.valid) {
        this.commonMethods.markFormGroupTouched(this.creditCardForm);
      }
      if (accountNo == "" || accountNo == null)
        $("#tokenValidationMessage").html("Invalid Card Number");
      return false;
    }
    let payment: PaymentModel = new PaymentModel();
    payment.WorkOrder = Object.assign({}, { ID: this.details.ID });
    let paymentType = this.paymentTypes.find(
      x => x.Code.toLowerCase() == "creditcard"
    );
    payment.PaymentType = paymentType;
    payment.PayerName = this.creditCardForm.controls["NameOnCard"].value;
    payment.Amount = parseFloat(
      this.creditCardForm.controls["Amount"].value.toFixed(2)
    );
    payment.CVV = this.creditCardForm.controls["CVV"].value;
    payment.PostalCode = this.creditCardForm.controls["ZipCode"].value;
    payment.Expiery =
      this.creditCardForm.controls["ExpMonth"].value +
      "/" +
      this.creditCardForm.controls["ExpYear"].value;
    payment.Comment = this.creditCardForm.controls["Comment"].value;
    payment.CardType = "";
    payment.Account = accountNo;
    if (this.ResetExpiry()) return true;

    this.spinnerServ.showloader(this.$viewContainerRef, this.modalCounter, 0);
    this.httpWOReviewService.SavePayment(payment).subscribe(
      response => {
        if (response != null) {
          this.details.WorkTicketPayment = response;
          this.EvPaymentUpdated.emit(response);
        }
        this.spinnerServ.hideLoader(this.$viewContainerRef, this.modalCounter);
        this.paymentSelectorCredit = false;
        this.ShowPostToAccToast(response);
        this.toastr.success("Payment saved successfully", "Success!");
        this.creditCardForm.markAsPristine();
        if (this.destroyTab) {
          setTimeout(() => {
            this.tabOpen.DestroyTab(this.tabCounter);
          }, 100);
        }
        else {
          this.tabOpen.unsavedChangedDetected({
            dirty: false,
            Index: this.tabCounter
          });
          this.isUnsavedTriggered = false;
        }
      },
      error => {
        this.spinnerServ.hideLoader(this.$viewContainerRef, this.modalCounter);
        if (!CommonMethods.CheckNullOrUndefined(error.error))
          this.toastr.showMultiLineError(error.error.Message, "Error");
      }
    );
  }

  public SaveOtherPayment() {
    if (this.paymentForm.valid) {
      let payment: PaymentModel = new PaymentModel();
      payment.WorkOrder = Object.assign({}, { ID: this.details.ID });
      let paymentType = this.paymentTypes.find(
        x => x.Code.toLowerCase() == "other"
      );
      payment.PaymentType = paymentType;
      payment.Amount = parseFloat(
        this.paymentForm.controls["Amount"].value.toFixed(2)
      );
      payment.Comment = this.paymentForm.controls["Comment"].value;
      payment.CardType = "";

      this.spinnerServ.showloader(this.$viewContainerRef, this.modalCounter, 0);
      this.httpWOReviewService.SavePayment(payment).subscribe(
        response => {
          if (response != null) {
            this.details.WorkTicketPayment = response;
            this.EvPaymentUpdated.emit(response);
          }
          this.spinnerServ.hideLoader(this.$viewContainerRef, this.modalCounter);
          this.paymentSelectorOther = false;
          this.ShowPostToAccToast(response);
          this.toastr.success("Payment saved successfully", "Success!");
          this.paymentForm.markAsPristine();
          if (this.destroyTab) {
            setTimeout(() => {
              this.tabOpen.DestroyTab(this.tabCounter);
            }, 100);
          }
          else {
            this.tabOpen.unsavedChangedDetected({
              dirty: false,
              Index: this.tabCounter
            });
            this.isUnsavedTriggered = false;
          }
        },
        error => {
          this.spinnerServ.hideLoader(this.$viewContainerRef, this.modalCounter);
          if (!CommonMethods.CheckNullOrUndefined(error.error))
            this.toastr.showMultiLineError(error.error.Message, "Error");
        }
      );
    } else {
      this.commonMethods.markFormGroupTouched(this.paymentForm);
    }
  }

  public SaveChequPayment() {
    if (this.paymentForm.valid) {
      let payment: PaymentModel = new PaymentModel();
      payment.WorkOrder = Object.assign({}, { ID: this.details.ID });
      let paymentType = this.paymentTypes.find(
        x => x.Code.toLowerCase() == "check"
      );
      payment.PaymentType = paymentType;
      payment.Amount = parseFloat(
        this.paymentForm.controls["Amount"].value.toFixed(2)
      );
      payment.PayerName = this.paymentForm.controls["NameOnCheque"].value;
      payment.CheckNumber = this.paymentForm.controls["ChequeNumber"].value;
      payment.Comment = this.paymentForm.controls["Comment"].value;
      this.spinnerServ.showloader(this.$viewContainerRef, this.modalCounter, 0);
      this.httpWOReviewService.SavePayment(payment).subscribe(
        response => {
          if (response != null) {
            this.details.WorkTicketPayment = response;
            this.EvPaymentUpdated.emit(response);
          }
          this.spinnerServ.hideLoader(this.$viewContainerRef, this.modalCounter);
          this.paymentSelectorCheck = false
          this.ShowPostToAccToast(response);
          this.toastr.success("Payment saved successfully", "Success!");
          this.paymentForm.markAsPristine();
          if (this.destroyTab) {
            setTimeout(() => {
              this.tabOpen.DestroyTab(this.tabCounter);
            }, 100);
          }
          else {
            this.tabOpen.unsavedChangedDetected({
              dirty: false,
              Index: this.tabCounter
            });
            this.isUnsavedTriggered = false;
          }
        },
        error => {
          this.spinnerServ.hideLoader(this.$viewContainerRef, this.modalCounter);
          if (!CommonMethods.CheckNullOrUndefined(error.error))
            this.toastr.showMultiLineError(error.error.Message, "Error");
        }
      );
    } else {
      this.commonMethods.markFormGroupTouched(this.paymentForm);
    }
  }

  public ResetExpiry() {
    let minMonth = new Date().getMonth() + 1;
    let minYear = new Date().getFullYear();
    let month = parseInt(this.creditCardForm.controls["ExpMonth"].value);
    let year = parseInt(this.creditCardForm.controls["ExpYear"].value);
    if (year < minYear || (year <= minYear && month < minMonth)) {
      this.invalidExpiry = true;
      return true;
    } else {
      this.invalidExpiry = false;
      return false;
    }
  }

  private InitializePaymentForm(paymentType: any) {
    this.paymentForm = this.frmbuilder.group({
      PaymentType: new FormControl(paymentType),
      Amount: new FormControl(this.minAmount == 0.01 ? 0 : this.minAmount, [
        Validators.required,
        Validators.min(0.01),
        Validators.max(this.minAmount)
      ]),
      NameOnCheque: new FormControl("", Validators.required),
      ChequeNumber: new FormControl("", Validators.required),
      Comment: new FormControl(),
      Note: new FormControl("")
    });
    if (paymentType == 3) {
      // Cheque
      this.paymentForm.controls["ChequeNumber"].setValidators(
        Validators.required
      );
      this.paymentForm.controls["NameOnCheque"].setValidators(
        Validators.required
      );
    } else {
      this.paymentForm.controls["NameOnCheque"].clearValidators();
      this.paymentForm.controls["ChequeNumber"].clearValidators();
    }
  }

  private InitializeCreditCardForm() {
    this.creditCardForm = this.frmbuilder.group({
      NameOnCard: new FormControl("", [
        Validators.required,
        this.commonMethods.noWhitespaceValidator
      ]),
      ExpMonth: new FormControl("01"),
      ExpYear: new FormControl(2019),
      CVV: new FormControl("", Validators.required),
      Amount: new FormControl(this.minAmount == 0.01 ? 0 : this.minAmount, [
        Validators.required,
        Validators.min(0.01),
        Validators.max(this.minAmount)
      ]),
      Comment: new FormControl(""),
      ZipCode: new FormControl("", [
        this.commonMethods.ZipCodeValidator,
        this.commonMethods.noWhitespaceValidator
      ])
    });
  }

  /** Returns true if need to show confirmation box before making payment */
  private IsShowConfirmBox() {
    return this.workTicketPayment.BalanceOwed > 0 && this.qbVersion != "none" && this.subStatus == Constants.WOStaticStatus().posted;
  }

  /**
   * Show confirmation box for payment
   * @param confirmMessage
   * @param confirmActionOkBtn
   * @param confirmActionCancelBtn
   * @param paymentType
   */
  private ShowPaymentConfirmBox( confirmMessage, confirmActionOkBtn, confirmActionCancelBtn, paymentType) {
    this.confirmationBox = true;
    this.confirmMessage = confirmMessage;
    this.confirmActionOkBtn = confirmActionOkBtn;
    this.confirmActionCancelBtn = confirmActionCancelBtn;
    this.paymentType = paymentType;
    this.showPaymentOverlay = true;
  }

  /** Hide and clear confirmation box values */
  private HideAndClearConfimBox() {
    this.confirmationBox = false;
    this.confirmMessage = "";
    this.isError = false;
    this.confirmActionCancelBtn = "";
  }

  /**
   * Show Post to accounting success toast msg based on IsPosted and checks qbVersion
   * @param response Should contain IsPosted
   */
  private ShowPostToAccToast(response) {
    if (!CommonMethods.CheckNullOrUndefined(response.IsPosted) && this.qbVersion !== "none" && this.subStatus == Constants.WOStaticStatus().posted) {
      if (response.IsPosted) {
        this.toastr.success("Posted to accounting");
      }
    }
  }

  private FillYearList() {
    let currentYear = new Date().getFullYear();
    let i = 15;

    while (i > 0) {
      this.yearList.push(currentYear);
      currentYear++;
      i--;
    }
  }
  //#endregion
}
